import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { VoiceSettingsProvider } from "@/contexts/VoiceSettingsContext";
import { MicPermissionProvider } from "@/contexts/MicPermissionContext";
import { lazy, Suspense } from "react";
import Home from "./pages/Home";

const Chat = lazy(() => import("./pages/Chat"));
const MyRecipes = lazy(() => import("./pages/MyRecipes"));
const HowItWorks = lazy(() => import("./pages/HowItWorks"));
const FoodSafety = lazy(() => import("./pages/FoodSafety"));
const Auth = lazy(() => import("./pages/Auth"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const Pricing = lazy(() => import("./pages/Pricing"));
const SubscriptionSuccess = lazy(() => import("./pages/SubscriptionSuccess"));
const Admin = lazy(() => import("./pages/Admin"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <VoiceSettingsProvider>
        <MicPermissionProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
          <AuthProvider>
            <Suspense fallback={<div className="flex min-h-screen items-center justify-center"><span className="text-muted-foreground">Loading…</span></div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/my-recipes" element={<MyRecipes />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/food-safety" element={<FoodSafety />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/subscription-success" element={<SubscriptionSuccess />} />
              <Route path="/admin" element={<Admin />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
            </Suspense>
          </AuthProvider>
          </BrowserRouter>
        </MicPermissionProvider>
      </VoiceSettingsProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
